import { useEffect, useState } from 'react'
import { getEmbedConfig, subscribeEmbedConfig, type EmbedConfig } from '@utils/embedConfig'

export function useEmbedConfig(): EmbedConfig {
  const [config, setConfig] = useState<EmbedConfig>(getEmbedConfig)
  useEffect(() => subscribeEmbedConfig(setConfig), [])
  return config
}
